// extracted by mini-css-extract-plugin
export default {"explanation":"RepayEarly_explanation","explanationAmount":"RepayEarly_explanationAmount","cta":"RepayEarly_cta ApprovedView_cta buttons_button"};